import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { Button } from '@cuemath/web-comps';

import { COLORS, FlexView, Row, Separator } from '@cuemath/comps';
import { Message } from 'semantic-ui-react';

import { get as getListCount } from 'actions/list-count';
import {
  getAll as getTeacherList,
  invalidateList as invalidateTeacherList,
} from 'actions/teacher-list';
import { getAll as getCreds } from 'actions/creds';
import { get as getTeacherSlots } from 'actions/teacher-slots';
import { get as getConfig } from 'actions/configs';
import { getAll as getPrograms } from 'actions/programs';
import { post as exportTeachers } from 'actions/teacher-export';
import { openModal, closeModal } from 'actions/modal';
import { patch as editTeacher } from 'actions/teachers';
import { Heading } from 'comps';

import TeacherList from './list-v1';
import Search from 'modules/list/new-search-bar';

import { RESULTS_PER_PAGE } from 'constants/list';
import {
  FORM_ACTIONS,
  MODAL_FORM,
  MODAL_CONFIRMATION_ACTIONS,
  teacherCredStateOptions,
} from 'constants/form';
import { USER_CONFIG, BATCHES_CONFIG, RESOURCE_URL } from 'constants/api';
import MODAL from 'constants/modal';
import { SelectInput } from 'modules/form/index';

const ButtonWrapper = styled(Button)`
  margin: auto 12px;
`;

const Field = styled(SelectInput)`
  margin-left: 18px;
  width: 350px;
`;

const MsgWrapper = styled.div`
  width: 350px;
  margin-left: 280px;
`;

class TeacherTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      countData: null,
      teacherId: null,
      teacherPatch: store.patch(),
      teacherExportPost: store.post(),
      filterParam: null,
      segmentFilter: null,
      credListData: [],
      exportNotify: {},
    };
  }

  static getDerivedStateFromProps(
    { teacherList, credList, listCount, teacherExport },
    { page, teacherExportPost },
  ) {
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const newState = {};
    const credListGetAll = store.getAll(credList);
    const newTeacherExportPost = store.post(teacherExport, teacherExportPost.id);

    if (credListGetAll && credListGetAll.isLoaded) {
      newState.credListData = credListGetAll.data;
    }
    if (newTeacherExportPost.resolved) {
      if (newTeacherExportPost.resolved.isCreated) {
        newState.exportNotify = {
          msg:
            'Export Successful. Please find the email with attached export at your registered email address.',
          type: 'info',
        };
      } else if (newTeacherExportPost.resolved.isCreatingFailed) {
        const { __CODE__: code } = newTeacherExportPost.resolved;
        newState.exportNotify = {
          msg:
            code === 403
              ? 'You do not have access, apply a filter!!'
              : 'Something went wrong!!',
          type: 'error',
        };
      }
    }

    newState.listData = store.getAll(teacherList, listParams);
    newState.countData = store.get(listCount, RESOURCE_URL.teachers, countParams);

    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    const { page } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const filterData = { page, per_page: RESULTS_PER_PAGE };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };

    actions.getTeacherList(listParams, filterData);
    actions.getListCount(RESOURCE_URL.teachers, countParams, countFilterParams);
    actions.getConfig(USER_CONFIG);
    actions.getConfig(BATCHES_CONFIG);
    actions.getCreds();
    actions.getPrograms();
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions } = this.props;
    const { page, searchKey, listData, filterParam, segmentFilter } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const filterData = { page, per_page: RESULTS_PER_PAGE };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };

    if (searchKey) {
      filterData.search = searchKey;
      countFilterParams.search = searchKey;
    }

    if (segmentFilter) {
      filterData.cred_id_status = segmentFilter;
      countFilterParams.cred_id_status = segmentFilter;
    }

    const isListStale = !!(listData && listData.isStale);

    if (
      prevState.searchKey !== searchKey ||
      prevState.page !== page ||
      filterParam !== prevState.filterParam ||
      segmentFilter !== prevState.segmentFilter ||
      isListStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
            countFilterParams[key] = value;
          } else {
            if (value !== null) {
              filterData[key] = value;
              countFilterParams[key] = value;
            }
          }
        });
      }
      actions.getTeacherList(listParams, filterData);
      actions.getListCount(RESOURCE_URL.teachers, countParams, countFilterParams);
    }
  }

  openTeacherForm = ({ formType, data }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        MODAL_FORM.TEACHER,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: MODAL.HEIGHT,
        },
        { formType, data },
      );
    }
  };

  onPageChange = newPage => {
    this.setState({ page: newPage });
  };

  onViewSlots = teacher => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.TEACHER,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, data: teacher, tab: 2, fromSeeSlots: true },
    );
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onSegmentChange = segment => {
    let segmentData = null;

    if (segment && Array.isArray(segment)) segmentData = segment.map(data => data.value);
    this.setState({ segmentFilter: segmentData });
  };

  onConfirmation = value => {
    if (value === MODAL_CONFIRMATION_ACTIONS.CONFIRMED) {
      const { actions } = this.props;
      const {
        teacherId,
        teacherPatch: { id },
      } = this.state;
      const data = {
        state: 'INACT',
      };

      if (teacherId) {
        actions.editTeacher(id + teacherId, teacherId, data);
      }
    } else {
      this.setState({
        archiveTeacher: false,
      });
    }
  };
  exportQueryCSV = () => {
    const {
      segmentFilter,
      filterParam,
      teacherExportPost: { id },
    } = this.state;
    const { actions } = this.props;
    const filterData = {};

    if (filterParam && Array.isArray(filterParam) && filterParam.length > 0) {
      filterParam.forEach(({ value, id }) => {
        if (value !== null) filterData[id] = value;
      });
    }

    if (segmentFilter && Array.isArray(segmentFilter) && segmentFilter.length > 0) {
      filterData['cred_id_status'] = segmentFilter.map(s => {
        const [cred_id, status] = s.split('#');
        return { cred_id: cred_id, status: status };
      });
    }

    actions.exportTeachers(id, { query: filterData });
  };

  getCredOptions = credList => {
    const credOptions = [];
    credList.forEach(item => {
      teacherCredStateOptions.forEach(subItem => {
        credOptions.push({
          label: `${item.name} ${subItem.label}`,
          value: `${item.id}#${subItem.value}`,
        });
      });
    });
    return credOptions;
  };

  onSearch = searchKey => {
    if (searchKey !== this.state.searchKey && (this.state.searchKey || searchKey))
      this.setState({ searchKey: searchKey });
  };

  render() {
    const {
      page,
      searchKey,
      listData,
      countData,
      credListData,
      exportNotify: { msg: exportMsg, type: exportMsgType },
      filterParam,
    } = this.state;
    const { data: queryCount = 0, isProcessing } = countData || {};
    const credOptions = this.getCredOptions(credListData || []);

    return (
      <>
        <FlexView gutter={16}>
          <Row justifyContent="space-between" align-items="center">
            <Heading>Teacher List ({`${queryCount}`})</Heading>
            <ButtonWrapper
              label="Download CSV"
              onClick={this.exportQueryCSV}
              size="xsmall"
              backgroundColor="transparent"
              align="right"
            />
          </Row>
          <Separator transparent height="6" />
          <Row alignItems="center">
            <Search
              showNewSearchBar={true}
              onSearch={this.onSearch}
              placeholder="Search Teachers..."
            />
            <Field
              name="segment"
              onChange={this.onSegmentChange}
              options={credOptions}
              isDisabled={!(credOptions && credOptions.length > 0)}
              isMulti={true}
              placeholder="Filter Creds..."
              theme={theme => ({
                ...theme,
                borderRadius: '8px',
                colors: {
                  ...theme.colors,
                  primary25: 'silver',
                  primary: 'black',
                },
              })}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  minHeight: '45px',
                  borderColor: COLORS.GRAY_XLIGHT,
                }),
              }}
            />
            <MsgWrapper>
              {exportMsg && (
                <Message error={exportMsgType === 'error'}>{exportMsg}</Message>
              )}
            </MsgWrapper>
          </Row>
        </FlexView>
        <TeacherList
          teachers={!!listData ? listData.data : []}
          page={page}
          searchKey={searchKey}
          openTeacherForm={this.openTeacherForm}
          onViewSlots={this.onViewSlots}
          onFilter={this.onFilter}
          countData={!!countData ? countData.data : 0}
          onPageChange={this.onPageChange}
          isProcessing={isProcessing}
          queryCount={queryCount}
          filterParam={filterParam}
        />
      </>
    );
  }
}

export default connect(
  ({
    teacherList,
    credList,
    listCount,
    teacherSlots,
    teachers,
    configs,
    teacherExport,
  }) => ({
    teacherList,
    listCount,
    credList,
    teacherSlots,
    teachers,
    teacherExport,
    userConfig: store.get(configs, USER_CONFIG),
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getListCount,
        getTeacherList,
        getCreds,
        getConfig,
        getPrograms,
        openModal,
        getTeacherSlots,
        invalidateTeacherList,
        editTeacher,
        closeModal,
        exportTeachers,
      },
      dispatch,
    ),
  }),
)(TeacherTab);
